import { useLogo } from "@/hooks/useLogo";
import { Bell } from "lucide-react";

const DARK_MODE_LOGO = "/lovable-uploads/jayco-logo-white.png";

interface MobileAppHeaderProps {
  title?: string;
  rightAction?: React.ReactNode;
}

export function MobileAppHeader({ title, rightAction }: MobileAppHeaderProps) {
  const { logoSvgUrl } = useLogo();

  return (
    <header className="sticky top-0 z-40 bg-background backdrop-blur-xl border-b border-border/30">
      <div className="flex items-center justify-center h-20 px-4">
        <img src={logoSvgUrl} alt="Logo" className="h-[4.5rem] w-auto dark:hidden" />
        <img src={DARK_MODE_LOGO} alt="Logo" className="h-14 w-auto hidden dark:block" />
      </div>
      {(title || rightAction) && (
        <div className="flex items-center justify-between px-4 pb-3">
          <h1 className="text-xl font-bold text-foreground">{title}</h1>
          {rightAction && <div>{rightAction}</div>}
        </div>
      )}
    </header>
  );
}
